import { getFullPlayerName } from "@/helpers/player";
import { formatDate } from "@/lib/utils";
import type { MatchDto } from "@/types/app/MatchDto";
import { Card, CardBody } from "@nextui-org/react";
import { YouTube } from "./icons/YouTube";

type MatchCardProps = {
	match: MatchDto;
	type: "match" | "result";
	size?: "sm" | "lg";
	hasExtendedData?: boolean;
	customTitle?: string;
};

export const MatchCard = ({
	match,
	type,
	size,
	hasExtendedData,
}: MatchCardProps) => {
	return (
		<Card
			className={`bg-default-200 ${size === "sm" ? "min-w-96" : "min-w-full min-h-32"}`}
		>
			<CardBody className="grid grid-cols-3 gap-2 items-center">
				<div className="flex flex-col mx-auto items-center justify-start gap-1">
					<span className="text-md uppercase font-semibold">
						{getFullPlayerName(match.homePlayer) ?? "Neurčeno"}
					</span>
					{hasExtendedData && type === "result" && (
						<span>Místo: {match.place ?? "-"}</span>
					)}
				</div>
				<div className="flex flex-col mx-auto items-center text-center">
					<h3 className="font-bold uppercase">{match.roundName}</h3>
					<span className="text-sm">
						{match.date ? formatDate(match.date, true) : "Datum neurčeno"}
					</span>
					{type === "result" && match.score && (
						<>
							<span className="font-bold">{match.score}</span>
							<span>
								{`(${match.set1} ${match.set2}${match.set3 ? ` ${match.set3}` : ""})`}
							</span>
						</>
					)}
					{hasExtendedData && type === "match" && (
						<span>Odehráno: {match.score !== null ? "ANO" : "NE"}</span>
					)}
				</div>
				<div className="flex flex-col mx-auto items-center justify-end gap-1">
					<span className="text-md uppercase font-semibold text-right">
						{getFullPlayerName(match.awayPlayer) ?? "Neurčeno"}
					</span>
					{hasExtendedData && type === "result" && (
						<div className="flex flex-col gap-1 items-center justify-end">
							<span className="text-md uppercase font-semibold text-right">
								Poznámka: {match.notes ?? "-"}
							</span>
							{match.video && (
								<a
									href={match.video}
									target="_blank"
									className="hover:text-danger transition-all duration-200 cursor-pointer"
								>
									<YouTube />
								</a>
							)}
						</div>
					)}
				</div>
			</CardBody>
		</Card>
	);
};
